// 企业认证状态枚举
export enum EnterpriseStatus {
  UNVERIFIED = 0,   // 未认证
  VERIFYING = 1,    // 认证中
  VERIFIED = 2,     // 已认证
  REJECTED = 3      // 认证被拒绝
}

// 身份类型枚举
export enum IdentityTypeEnum {
  PERSONAL = 'personal',   // 个人身份
  ENTERPRISE = 'enterprise' // 企业身份
}

// 身份信息接口（与移动端保持一致）
export interface Identity {
  type: IdentityTypeEnum      // 身份类型：个人 或 企业
  id: number | string         // 身份ID（个人为用户ID，企业为企业ID）
  name: string                // 身份名称（个人固定为"个人"，企业为企业名称）
  verified: boolean           // 是否已认证
  verifyStatus?: number       // 认证状态详情
  role?: string               // 角色（仅企业身份有效）
  roleCode?: number           // 角色代码（仅企业身份有效）
}

export interface Enterprise {
  id: number
  name: string
  creditCode?: string
  legalPerson?: string
  contactPhone?: string
  address?: string
  status: number // 认证状态: 0-未认证, 1-认证中, 2-已认证, 3-认证被拒绝
  role?: number // 当前用户在企业中的角色: 1-所有者 2-管理员 3-普通成员
  memberRole?: 'admin' | 'member' // 兼容旧字段
  memberCount?: number // 成员数量
  creatorId?: number
  createTime: string
}

export interface EnterpriseMember {
  id: number
  enterpriseId: number
  userId: number
  role: number // 1-所有者 2-管理员 3-普通成员
  joinTime: string
  // 关联的用户信息
  nickname?: string
  avatar?: string
  mobile?: string
  userName?: string // 兼容旧字段
  userMobile?: string // 兼容旧字段
}
